import React, { useState, useEffect } from "react";
import { Modal, StyleSheet, Pressable, Text, View } from "react-native";
import CloseButton from "@assets/svg/CloseButton";
import * as Animatable from "react-native-animatable";
import cartPageKeys from "@constants/cartPageKeys";
import Button from "@components/Button";
import metrics from "@constants/metrics";
import t from "@constants/localization";

const PATH = "screens/PlaceOrder/AddressConfirmationModal";

export default function AddressConfirmationModal(props) {
  const {
    visible,
    onClose = () => {},
    details = [],
    onAddressChangeClick = () => {},
    onConfirmOrderClick = () => {},
  } = props;
  const [shippingDetails, setshippingDetails] = useState({});

  useEffect(() => {
    setshippingDetails(
      details.find((c) => c.type === cartPageKeys.SHIPPING_DETAILS),
    );
  }, [details]);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    setModalVisible(visible);
    return () => {};
  }, [visible]);

  return shippingDetails ? (
    <>
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        statusBarTranslucent
      >
        <View style={styles.modalChild}>
          <Animatable.View
            duration={300}
            useNativeDriver={true}
            delay={0}
            animation="slideInUp"
            style={styles.addressContainer}
          >
            <View style={styles.warningText}>
              <Text style={styles.title}>
                {t(`${PATH}/cnfmAddForDelivery`)}
              </Text>
              <Pressable
                onPress={() => {
                  setModalVisible(!modalVisible);
                  onClose();
                }}
              >
                <CloseButton />
              </Pressable>
            </View>
            <View style={{ marginTop: 24, paddingHorizontal: 16 }}>
              <Text style={styles.name}>{shippingDetails?.name}</Text>
              <Text style={styles.address}>{shippingDetails?.address}</Text>
            </View>
            <View style={styles.buttonContainer}>
              <Button
                borderRadius={6}
                btnText={t(`${PATH}/changeAdd`)}
                height={40}
                fontBold={false}
                textStyle={styles.buttonTextStyle}
                onPress={() => onAddressChangeClick()}
                buttonStyle={styles.buttonStyle}
                containerStyle={{
                  alignSelf: "center",
                }}
              />
              <Button
                borderRadius={6}
                btnText={t(`${PATH}/cnfmAdd`)}
                height={40}
                fontBold={false}
                textStyle={styles.buttonTextStyle}
                onPress={() => onConfirmOrderClick(true)}
                buttonStyle={styles.buttonStyle}
                containerStyle={{
                  alignSelf: "center",
                }}
              />
            </View>
          </Animatable.View>
        </View>
      </Modal>
    </>
  ) : null;
}

const styles = StyleSheet.create({
  addressContainer: {
    minHeight: 230,
    elevation: 5,
    width: "100%",
    backgroundColor: "white",
    paddingBottom: 10,
  },
  title: {
    fontSize: 18,
    fontFamily: "NotoSansDevanagari-SemiBold",
    color: "rgba(0, 0, 0, 0.86)",
  },
  name: {
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 14,
    color: "rgba(0, 0, 0, 0.86)",
    marginBottom: 10,
  },
  address: {
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 14,
    color: "rgba(0, 0, 0, 0.56)",
  },
  buttonStyle: {
    borderWidth: 1,
    borderColor: "#E40046",
    backgroundColor: "transparent",
    width: metrics.screenWidth / 2 - 25,
  },
  buttonTextStyle: {
    fontFamily: "NotoSansDevanagari-SemiBold",
    fontSize: 14,
    color: "#E40046",
  },
  buttonContainer: {
    flexDirection: "row",
    justifyContent: "space-evenly",
    marginTop: 32,
  },
  warningText: {
    height: 30,
    flexDirection: "row",
    marginTop: 20,
    justifyContent: "space-between",
    paddingHorizontal: 18,
  },
  modalChild: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "flex-end",
  },
});
